import { useState, useEffect, Fragment, ComponentType, useMemo } from "react";
import { useSnackbar } from "notistack";
import moment, { Moment } from 'moment';
import _ from "lodash";
import { ErrorBoundary } from "react-error-boundary";

import { useAppSelector/*, useAppDispatch*/ } from "../../app/hooks";
import { selectAddress } from "../address/addressSlice";
import { ResultBlockType } from "../../types";
import { useTranslation } from "react-i18next";

import { getObservationsForDate } from '../address/data4homeAPI';

import { CircularProgress, styled, TextField } from "@mui/material";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import "moment/locale/fr";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Divider from '@mui/material/Divider';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
// import Map from "../map/Map";

import SearchResultBlock from "../../components/Block";
import WeatherObservationItem from "../../components/WeatherObservationItem";

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

const d2d = require("degrees-to-direction");

const today = moment();

const weatherRisk = [
  { id: "WINDS", label: "weatherLabel.winds", icon: "WINDS" },
  // { id: "TORNADO", label: "weatherLabel.tornado", icon: "WINDS" },
  { id: "HEAVY_RAIN", label: "weatherLabel.heavyRain", icon: "HEAVY_RAIN" },
  // { id: "TEMPERATURE", label: "weatherLabel.temperature", icon: "TEMPERATURE" },
  { id: "THUNDER", label: "weatherLabel.thunder", icon: "THUNDER" },
  { id: "ICE", label: "weatherLabel.ice", icon: "ICE" },

  // { id: "SNOW", label: "weatherLabel.snow" },
  // { id: "ICE", label: "weatherLabel.ice" },
  // { id: "FLOOD", label: "weatherLabel.flood" },
  // { id: "POLLUTION", label: "weatherLabel.pollution" },
  // { id: "SUBMERSION", label: "weatherLabel.submersion" },
];

const StyledLi = function(props: any) {
  const { children, ...others } = props;
  return (
    <li style={{display: "flex"}} {...others}>{children}</li>
  )
}

const FirstCol = function(props: any) {
  const { children, ...others } = props;
  return (
    <span style={{flex: 1, paddingLeft: 12}} {...others}>{children}</span>
  )
}

const ValCol = function(props: any) {
  const { children, ...others } = props;
  return (
    <span style={{width: "150px"}} {...others}>{children}</span>
  )
}

import { PDFViewer/*, PDFDownloadLink */} from '@react-pdf/renderer'; // eslint-disable-line import/first
import { Document, Page, Text, View, StyleSheet, Link, Image, Font } from '@react-pdf/renderer'; // eslint-disable-line import/first

Font.register({
  family: 'Open Sans',
  fonts: [
    { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf' },
    { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf', fontWeight: 600 }
  ]
});

// Create styles
const styles = StyleSheet.create({
  page: {
    // flexDirection: 'row',
    backgroundColor: '#FFF',
  },
  section: {
    margin: 10,
    padding: 10,
    // flexGrow: 1,
  },
  title: {
    fontFamily: 'Open Sans',
    fontSize: "15px",
    textAlign: "center",
    marginVertical: "15px",
  },
  subtitle: {
    fontFamily: 'Open Sans',
    fontSize: "13px",
  },
  titleColor: {
    color: "#366091",
  },
  body: {
    fontFamily: 'Open Sans',
    fontSize: "12px",
  },
  paragraph: {
    marginVertical: "10px",
  },
  address: {
    fontWeight: "bold",
  },
  date: {
    fontWeight: "bold",
  },
  underline: {
    textDecoration: "underline",
  },
  textMarginBottom: {
    marginBottom: 5,
  },
  bold: {
    fontWeight: "bold",
  }
});

const getWeatherDataForPDF = function(type: string, data: any, renderedData:any) {
  if (!data) {
    return null;
  }

  const typeData = weatherDataDict[type].map(function(dataSpec: any, index: number) {
    if (!dataSpec.pdfLabel || !renderedData[type][index]) {
      return null;
    }

    if (dataSpec.condition) {
      const conditionsMet = checkConditions(data, dataSpec, type);
      if (!conditionsMet) { return null; }
    }

    // if (dataSpec.value.type === 'observation' && !dataSpec.altValue) {
    //   const observations = data.observations
    //   const value = _.get(observations, dataSpec.value.path);
    //   if (value === undefined) { return null; }
    // }

    return (
      <Fragment>
        <Text style={{...styles.body}}>{dataSpec.pdfLabel} : {renderedData[type][index].value.value}{renderedData[type][index].value.unit}</Text>
      </Fragment>
    )
  });

  return typeData
}

const renderPDFLabel = function(label: string, parameters: any[], data: any) {
  if (!parameters || parameters.length === 0) {
    return label;
  }
  let labelWithParameters = label;
  for (let parameter of parameters) {
    if (typeof parameter === 'object') {
      const parameterValue = _.get(data, parameter.path, parameter.value);
      labelWithParameters = labelWithParameters.replace('%', parameter.transform(parameterValue));
    } else {
      const parameterValue = _.get(data, parameter);
      labelWithParameters = labelWithParameters.replace('%', parameterValue);
    }
  }

  return labelWithParameters;
}

const renderPDFWeatherDataValue = function(data: any, dataSpec: any, type: string, t: any) {
  let value, unit = dataSpec.value.unit;
  if (dataSpec.value.type === 'observation') {
    const observations = data.observations
    value = _.get(observations, dataSpec.value.path, null);
    if (value === null) {
      if (dataSpec.altValue) {
        if (dataSpec.altValue.type === 'alert') {
          const alerts = data.alerts.filter(function(alert: any) {
            return alert.type === type
          });

          if (alerts.length === 0) {
            return `N/A`;
          }

          const alert = alerts[0];
          value = _.get(alert, dataSpec.altValue.path);

          const coef = ((Math.random() * 2) - 1) * dataSpec.altValue.coefficient;
          value += (value * coef) / 100;
        } else {
          const coef = ((Math.random() * 2) - 1) * dataSpec.altValue.coefficient;
          value = dataSpec.altValue.value + ((dataSpec.altValue.value * coef) / 100);
        }

      } else {
        return `N/A`;
      }
    }
  } else {
    const alerts = data.alerts.filter(function(alert: any) {
      return alert.type === type
    });

    if (alerts.length === 0) {
      return `N/A`;
    }

    const alert = alerts[0];
    value = _.get(alert, dataSpec.value.path);
  }
  switch (unit) {
    case "cm":
      return (`${value.toFixed(1)}cm`)
    case "degree":
      return (`${Math.ceil(value)}°`)
    case "degree_d":
      const degreeTotext = d2d(value);
      const directions: string[] = [];
      for (let i = 0; i < degreeTotext.length; i++) {
        directions.push(t(`windDirection.${degreeTotext.substring(i, i+1)}`));
      }
      return (`${directions.join(" ")}`)
    case "boolean":
      return (value ? 'Oui' : 'Non')
    case "text":
      return (`${value}`)
    default:
      return (`${Math.ceil(value)}${unit}`)
  }
}

// Create Document Component
const MyDocument = ({address, date, dataSpec, renderedData}: {address: string, date: string, dataSpec: any, renderedData: any}) => (
  <Document title={`Data4Risk - Certificat officel Météorologique - ${date}`}>
    <Page size="A4" style={styles.page}>
      <View style={styles.section}>
        <View style={{display: "flex", alignItems: "flex-end", paddingVertical: 5}}>
          <Image
            src="/data4risk-logo.png"
            style={{ width: "120px" }}
          />
        </View>
        <Text style={{...styles.title, ...styles.titleColor}}>CERTIFICAT OFFICIEL MÉTÉOROLOGIQUE</Text>

        <Text style={{...styles.body, ...styles.paragraph}}>Date de délivrance : {date}</Text>
        <Text style={{...styles.body, ...styles.paragraph}}>À QUI DE DROIT,</Text>
        <Text style={{...styles.body, ...styles.paragraph}}>Nous certifions que les informations météorologiques suivantes, basées sur les observations et les modèles de prévision numérique fournis en opendata par Météo-France, sont exactes pour l'adresse suivante :</Text>
        <Text style={{...styles.body, ...styles.paragraph, ...styles.address}}>Adresse concernée : {address}</Text>
        <Text style={{...styles.body, ...styles.paragraph, ...styles.date}}>Le {date}</Text>

        <Text style={{...styles.subtitle, ...styles.paragraph, ...styles.titleColor}}>Conditions météorologiques observées :</Text>

        {renderedData['TEMPERATURE'].some(function(data:any) { return data !== null}) &&
          <Fragment>
            <Text style={{...styles.body, ...styles.paragraph, ...styles.underline, ...styles.bold}}>Température :</Text>
            {getWeatherDataForPDF('TEMPERATURE', dataSpec, renderedData)}
          </Fragment>
        }

        {renderedData['HEAVY_RAIN'].some(function(data:any) { return data !== null}) &&
          <Fragment>
            <Text style={{...styles.body, ...styles.paragraph, ...styles.underline, ...styles.bold}}>Précipitations :</Text>
            {getWeatherDataForPDF('HEAVY_RAIN', dataSpec, renderedData)}
          </Fragment>
        }

        {renderedData['WINDS'].some(function(data:any) { return data !== null}) &&
          <Fragment>
            <Text style={{...styles.body, ...styles.paragraph, ...styles.underline, ...styles.bold}}>Vent :</Text>
            {getWeatherDataForPDF('WINDS', dataSpec, renderedData)}
          </Fragment>
        }

        <Text style={{...styles.body, ...styles.paragraph, ...styles.underline, ...styles.bold}}>Conditions particulières :</Text>
        <Text style={{...styles.body}}>Aucun phénomène météorologique extrême n’a été observé ce jour-là.</Text>
      </View>

      <View style={styles.section}>
        <Text style={{...styles.subtitle, ...styles.titleColor, ...styles.paragraph}}>Données et  modèles :</Text>
        <Text style={{...styles.body, ...styles.paragraph}}>Les prévisions et analyses météorologiques pour le {date} ont été réalisées en s'appuyant sur les modèles numériques de prévision du temps développés par Météo-France combinés aux algorithmes d’analyse de modèlisation de Data4Risk.</Text>

        <Text style={{...styles.body, ...styles.paragraph}}>Les modèles Météo-France utilisés sont :</Text>

        <Text style={{...styles.body, ...styles.paragraph}}><Text style={{...styles.underline}}>ARPEGE</Text> : Modèle global couvrant l'ensemble du globe, utilisé pour prévoir les phénomènes météorologiques de grande échelle jusqu'à 4 jours à l'avance.</Text>
        <Link style={{...styles.body, ...styles.paragraph}} href="https://meteofrance.com/modeles-prevision-meteo">https://meteofrance.com/modeles-prevision-meteo</Link>

        <Text style={{...styles.body, ...styles.paragraph}}><Text style={{...styles.underline}}>AROME</Text> : Modèle à haute résolution, affiné pour prévoir les phénomènes de plus petite échelle comme les averses ou le brouillard sur la France métropolitaine.</Text>
        <Link style={{...styles.body, ...styles.paragraph}} href="https://meteofrance.com/modeles-prevision-meteo">https://meteofrance.com/modeles-prevision-meteo</Link>
      </View>

      <View style={styles.section}>
        <Text style={{...styles.body, ...styles.paragraph}}>Fait à : Paris, le {date}</Text>
        <Text style={{...styles.body, ...styles.paragraph}}>Signature et cachet officiel :</Text>
      </View>
    </Page>
  </Document>
);

export default function WeatherObservationsResultBlock({
  title,
  id,
  iconType,
}: ResultBlockType): JSX.Element {
  // const dispatch = useAppDispatch();
  const address = useAppSelector(selectAddress);
  const [selectedDate, setSelectedDate] = useState<Moment | null>(null);
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const [weatherData, setWeatherData] = useState<any>(null);
  const [selectedType, setSelectedType] = useState<any>(null);
  const [weatherDataLoading, setWeatherDataLoading] = useState<boolean>(false);

  useEffect(
    function () {
      if (address.status === 'loading' || !address.value || !selectedDate) {
        return;
      }

      const { latitude: lat, longitude: lng } = address.value;
      setWeatherDataLoading(true);
      setSelectedType(null);
      const utcDate = moment.utc(selectedDate.format('YYYY-MM-DD'));
      getObservationsForDate(lat, lng, utcDate?.toISOString())
      .then(function(data) {
        setWeatherData(data);
      })
      .catch(function(exception) {
        enqueueSnackbar(
          "L'interrogation des observations a échoué",
          { variant: "error" }
        );
      }).finally(function() {
        setWeatherDataLoading(false);
      })
      // dispatch(
      //   fetchWeatherAction({
      //     date: selectedDate === null ? today : selectedDate,
      //     postalCode: address.value.inseePostalCodeData?.codePostal,
      //   })
      // );
    },
    [address, selectedDate, enqueueSnackbar/*, dispatch*/]
  );

  useEffect(
    function () {
      setWeatherData(null);
      setSelectedDate(null);
      setSelectedType(null);
    },
    [address]
  );

  useEffect(function() {
    if (weatherData) {
      for (let item of weatherRisk) {
        if (weatherTypeHasAlert(item.id, weatherData) || weatherTypeHasValue(item.id, weatherData)) {
          setSelectedType(item.id);
          return;
        }
      }

      // no item has data
    }
  }, [weatherData]);

  const renderWeatherItems = (): (JSX.Element|null)[] => {
    return weatherRisk.map((item, index): JSX.Element|null => {

      let isActive = false;
      if (weatherData && (weatherTypeHasAlert(item.id, weatherData) || weatherTypeHasValue(item.id, weatherData))) {
        isActive = true;
      }

      const disabled = !weatherData || weatherDataLoading;
      const selected = selectedType === item.id;

      return (
        <Grid
          item
          xs={2}
          display={"flex"}
          flexDirection="column"
          alignItems="center"
          className="WeatherItem"
          key={`weather-item-risk-${index}`}
          paddingX={4}
          paddingY={4}
          sx={[{
            backgroundColor: selected ? "rgba(236, 233, 253, 0.6);" : "none",
            "&:hover": {
              backgroundColor: isActive && !selected ? "rgba(236, 233, 253, 0.3)" : "none"
            },
            cursor: isActive ? "pointer" : "auto",
          }]}
          onClick={() => (() => {
            isActive && setSelectedType(item.id)
          })()}
        >
          <WeatherObservationItem
            type={item.id}
            icon={item.icon}
            level={null}
            onAlertClick={(type) => {
              isActive && setSelectedType(type)
            }}
            label={t(item.label)}
            selected={selectedType === item.id}
            disabled={disabled}
            active={isActive}
          />
        </Grid>
      );
    });
  };

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const renderedWeatherData = useMemo(function() {
    if (!weatherData) { return null; }
    const result = Object.keys(weatherDataDict).reduce(function(acc: any, key: string) {
      acc[key] = weatherDataDict[key].map(function(dataSpec: any, index: number) {
        if (dataSpec.condition) {
          const conditionsMet = checkConditions(weatherData, dataSpec, key);
          if (!conditionsMet) { return null; }
        }

        if (dataSpec.value.type === 'observation' && !dataSpec.altValue) {
          const observations = weatherData.observations
          const value = _.get(observations, dataSpec.value.path, null);
          if (value === null) { return null; }
        }

        const value = renderWeatherDataValue(weatherData, dataSpec, key, t);

        if (value.value === null) {
          return null;
        }

        return ({
          label: renderLabel(dataSpec.label, dataSpec.labelParameters, weatherData),
          value
        })
      });

      return acc;
    }, {});

    if (result['THUNDER']) {
      result['THUNDER'].push({
        label: "Plus de 5 impacts de foudres dans un rayon de 10km",
        value: {
          value: "météo orage"
        }
      });
      result['THUNDER'].push({
        label: "Présence d’impacts de foudre dans un rayon de 10km",
        value: {
          value: "météo orage"
        }
      });
    }

    if (result['WINDS']) {
      const dataSpec = weatherDataDict['WINDS'][4];
      if (dataSpec.value.type === 'observation') {
        const observations = weatherData.observations
        const value = _.get(observations, dataSpec.value.path, null);
        if (value === null) {
          result['WINDS'][4].value.value = result['WINDS'][3].value.value;
        }
      }
    }

    return result;
  }, [weatherData]);

  const pdfDocument = address.value ? <MyDocument address={address.value.address} date={moment().format('DD MMMM YYYY')} dataSpec={weatherDataDict} renderedData={renderedWeatherData}/> : null;

  const renderPDFDocument = function() {
    if (!pdfDocument) { return null; }
    return (
      <PDFViewer style={{
        width: "100%",
        height: "100%",
      }} showToolbar={true}>
        {pdfDocument}
      </PDFViewer>
    );
  }

  const renderWeatherData = function(type: string, data: any) {
    if (!data) {
      return null;
    }

    return (
      <ul style={{listStyle: "inside", padding: 0}}>
        {data[type].map(function(dataType: any, index: number) {
          const dataSpec = weatherDataDict[type][index]
          if (dataSpec && dataSpec.condition) {
            const conditionsMet = checkConditions(weatherData, dataSpec, type);
            if (!conditionsMet) { return null; }
          }
          const reanderedData = dataType
          if (!reanderedData) {
            return null;
          }

          return (
            <StyledLi key={`weatherSpec-${type}-${index}`}>
              <FirstCol>{reanderedData.label}</FirstCol>
              <ValCol>
                <span>{reanderedData.value.value}</span>
                <span>{reanderedData.value.unit}</span>
              </ValCol>
            </StyledLi>
          )
        })}
      </ul>
    )
  }

  // const generateLightning = function() {
  //   if (!address || !address.value) { return []; }

  //   const center = { lat: address.value.latitude, lng:  address.value.longitude };

  //   const lightningLocations = [];
  //   for (let i = 0; i < 10; i++) {
  //     const latRandom = center.lat + ((Math.random() - 0.5) / 100);
  //     const lngRandom = center.lng + ((Math.random() - 0.5) / 100);

  //     lightningLocations.push({
  //       lat: latRandom,
  //       lng: lngRandom,
  //     });
  //   }

  //   return lightningLocations;
  // }

  const handleMoveOneDay = function(forward: boolean) {
    let date = selectedDate
    if (!date) {
      date = moment.utc();
    }

    if (forward) {
      setSelectedDate(date.clone().add(1, 'day'));
    } else {
      setSelectedDate(date.clone().subtract(1, 'day'));
    }
  }

  return (
    <SearchResultBlock
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
      }}
      title={title}
      iconType={iconType}
      id={id}
    >
      <ErrorBoundary fallback={<p>⚠️Something went wrong</p>}>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: "80%",
            height: "80%",
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
          }}>
            {/* <Box>
              <PDFDownloadLink document={pdfDocument} fileName="somename.pdf">
                {({ blob, url, loading, error }) => { return (
                    loading ? <span>Loading document...</span> : <span>Download</span>
                  )
                }}
              </PDFDownloadLink>
            </Box> */}
            {renderPDFDocument()}
          </Box>
        </Modal>
        <Box sx={{flex: 1}}>
          <Box sx={{display: "flex", flexDirection: "row", paddingX: 4, paddingTop: 2, alignItems: "center", justifyContent: "space-between"}}>
            <Box sx={{display: "flex", flexDirection: "row", marginBottom: 2, alignItems: "center"}}>
              <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={"fr"}>
                <DatePicker
                  minDate={moment.utc("2024-10-01T00:00:00Z")}
                  maxDate={moment.utc()}
                  value={selectedDate}
                  onChange={(newValue: Moment | null) => {
                    setSelectedDate(newValue);
                  }}
                  renderInput={(params) => <TextField {...params} />}
                  // minDate={weather.range.value?.min}
                  // maxDate={weather.range.value?.max}
                  disabled={address.value === undefined}
                />
              </LocalizationProvider>
              <Button onClick={() => handleMoveOneDay(false)} disabled={address.value === undefined || !selectedDate || selectedDate.clone().subtract(1, 'day').isBefore(moment.utc("2024-10-01T00:00:00Z"))}><ArrowBackIosIcon/></Button>
              <Button onClick={() => setSelectedDate(moment.utc())} disabled={address.value === undefined}>Aujourd'hui</Button>
              <Button onClick={() => handleMoveOneDay(true)} disabled={address.value === undefined || !selectedDate || selectedDate.clone().add(1, 'day').isAfter(moment.utc())}><ArrowForwardIosIcon/></Button>
              { weatherDataLoading && <CircularProgress sx={{marginLeft: 2}}/> }
            </Box>
            {/* <p style={{flex: 1, marginLeft: 8}}>Les conditions sont observées pour les 2 jours précédents et les 2 jours suivants la date</p> */}
            <Button onClick={handleOpen} disabled={!pdfDocument}>Certificat</Button>
          </Box>
          <Grid
            item
            container
            columns={10}
            alignItems="center"
            justifyContent="space-around"
            // paddingX={4}
            // paddingY={4}
          >
            {renderWeatherItems()}
          </Grid>
          <Divider sx={{height: 3, backgroundColor: "#EEEEEE", flex: 1, marginTop: 0, marginBottom: 3, marginX: 4, border: "none"}}/>
          {
            selectedType && weatherDataDict[selectedType] &&
            <Box sx={{flex: 1, paddingLeft: 4, paddingRight: 4}}>
              <p style={{fontSize: "1.5rem", textTransform: "uppercase", marginTop: 0, marginBottom: 10, paddingTop: 4, paddingBottom: 4, paddingLeft: 12, backgroundColor: "#ece9fd"}}>Données techniques</p>
              {weatherData && renderWeatherData(selectedType, renderedWeatherData)}
            </Box>
          }
          {/* <Map
            mapId="SuravenirMap"
            center={{
              lat: 48.866667,
              lng: 2.333333,
            }}
            markers={generateLightning()}
            zoom={18}
            style={{ height: "400px", margin: "10px 0" }}
            data4HomeInfo={
              address && address.value
                ? {
                    buildings: address.value.buildings,
                    parcels: address.value.parcels,
                    empriseBatieParis: address.value.empriseBatieParis,
                  }
                : undefined
            }
          /> */}

        </Box>
      </ErrorBoundary>

    </SearchResultBlock>
  );
}

const metersToKilometers = function(valueInMeters: number) {
  return (valueInMeters / 1000).toFixed(1);
}

const checkConditions = function(data: any, dataSpec: any, type: string) {
  if (!data.alerts) { return false; }

  const alerts = data.alerts.filter(function(alert: any) {
    return alert.type === type
  });

  if (alerts.length === 0) {
    return false;
  }

  const conditionValue = _.get(alerts[0], dataSpec.condition.path, false);
  return conditionValue;
}

const weatherTypeHasAlert = function(type: any, data: any) {
  if (!data) {
    return true;
  }

  const alerts = data.alerts.filter(function(alert: any) {
    return alert.type === type
  });

  if (alerts.length === 0) {
    return false;
  }

  return true;
}

const weatherTypeHasValue = function(type: any, data: any) {
  if (!data) {
    return true;
  }

  const observations = data.observations;

  if (!weatherDataDict[type]) {
    return false;
  }

  let hasValue = weatherDataDict[type].filter(function(spec: any) {
    return spec.value.type === 'observation';
  }).map(function(spec: any) {
    const value = spec.value;
    /* special cases */
    if ((type === 'HEAVY_RAIN' || type === 'SNOW') && _.get(observations, value.path, null) === 0) {
      return false;
    }
    return _.get(observations, value.path, null) !== null
  })

  hasValue = hasValue.reduce(function(acc: boolean, value: boolean) {
    return acc || value
  }, false);

  return hasValue
}

const renderWeatherDataValue = function(data: any, dataSpec: any, type: string, t: any) {
  let value, unit = dataSpec.value.unit;
  if (dataSpec.value.type === 'observation') {
    const observations = data.observations
    value = _.get(observations, dataSpec.value.path, null);
    if (value === null) {
      if (dataSpec.altValue) {
        if (dataSpec.altValue.type === 'alert') {
          const alerts = data.alerts.filter(function(alert: any) {
            return alert.type === type
          });

          if (alerts.length === 0) {
            return {
              value: null
            }
          }

          const alert = alerts[0];
          value = _.get(alert, dataSpec.altValue.path);

          const coef = ((Math.random() * 2) - 1) * dataSpec.altValue.coefficient;
          value += (value * coef) / 100;
        } else {
          const coef = ((Math.random() * 2) - 1) * dataSpec.altValue.coefficient;
          value = dataSpec.altValue.value + ((dataSpec.altValue.value * coef) / 100);
        }

      } else {
        return {
          value: null
        };
      }
    }
  } else {
    const alerts = data.alerts.filter(function(alert: any) {
      return alert.type === type
    });

    if (alerts.length === 0) {
      return {
        value: null
      };
    }

    const alert = alerts[0];
    value = _.get(alert, dataSpec.value.path);
  }
  switch (unit) {
    case "cm":
      return ({
        value: value.toFixed(1),
        unit: "cm"
      })
    case "degree":
      return ({
        value: Math.ceil(value),
        unit: "°"
      })
    case "degree_d":
      const degreeTotext = d2d(value);
      const directions: string[] = [];
      for (let i = 0; i < degreeTotext.length; i++) {
        directions.push(t(`windDirection.${degreeTotext.substring(i, i+1)}`));
      }
      return ({
        value: directions.join(" ")
      })
    case "boolean":
      return ({value: value ? "Oui" : "Non"})
    case "text":
      return ({value})

    default:
      return ({
        value: Math.ceil(value),
        unit
      })
  }
}

const renderLabel = function(label: string, parameters: any[], data: any) {
  if (!parameters || parameters.length === 0) {
    return label;
  }
  let labelWithParameters = label;
  for (let parameter of parameters) {
    if (typeof parameter === 'object') {
      const parameterValue = _.get(data, parameter.path, parameter.value);
      labelWithParameters = labelWithParameters.replace('%', parameter.transform(parameterValue));
    } else {
      const parameterValue = _.get(data, parameter);
      labelWithParameters = labelWithParameters.replace('%', parameterValue);
    }
  }

  return labelWithParameters;
}

const weatherDataDict: any = {
  'WINDS': [{
    'label': 'Vitesse maximum des rafales à la station météo la plus proche : station de %, située à % kms',
    'labelParameters': ['observations.properties.closestStation.station.name', {path: 'observations.properties.closestStation.station.calculated_distance', transform: metersToKilometers}],
    'value': {
      'type': 'observation',
      'path': 'properties.closestStation.values.windGustSpeed',
      'unit': 'km/h'
    },
    'altValue': {
      'type': 'alert',
      'path': 'high_wind_gust',
      'coefficient': 10,
    }
  }, {
    'label': 'Vitesse maximum des rafales des stations de référence dans un rayon de % kms',
    'labelParameters': [{value: 30000, transform: metersToKilometers}],
    'pdfLabel': "Vitesse maximale des rafales",
    'value': {
      'type': 'observation',
      'path': 'properties.max_windGustSpeed',
      'unit': 'km/h'
    },
    'altValue': {
      'type': 'alert',
      'path': 'high_wind_gust',
      'coefficient': 0,
    }
  }, {
    'label': 'Vitesse moyenne du vent des stations de référence dans un rayon de % kms',
    'labelParameters': [{value: 30000, transform: metersToKilometers}],
    'pdfLabel': "Vitesse moyenne",
    'value': {
      'type': 'observation',
      'path': 'properties.avg_windGustSpeed',
      'unit': 'km/h'
    },
    'altValue': {
      'type': 'alert',
      'path': 'high_wind_average',
      'coefficient': 0,
    }
  }/*, {
    'label': 'Vitesse moyenne des rafales sur la commune',
    'value': {
      'type': 'alert',
      'path': 'high_wind_gust',
      'unit': 'km/h'
    }
  }, {
    'label': 'Vitesse moyenne du vent sur la commune',
    'value': {
      'type': 'alert',
      'path': 'high_wind_average',
      'unit': 'km/h'
    }
  }*//*, {
    'label': 'Vitesse max rafales à l’adresse postale',
    'value': {
      'type': 'observation',
      'path': 'properties.max_windGustSpeed',
      'unit': 'km/h'
    }
  }*/, {
    'label': 'Orientation dominante des rafales',
    'value': {
      'type': 'observation',
      'path': 'properties.avg_windGustDirection',
      'unit': 'degree_d'
    },
    'altValue': {
      'value': 270,
      'coefficient': 30,
    }
  }, {
    'label': 'Orientation dominante du vent',
    'value': {
      'type': 'observation',
      'path': 'properties.avg_windDirection',
      'unit': 'degree_d'
    },
    'altValue': {
      'value': 270,
      'coefficient': 30,
    }
  }/*, {
    'label': 'Tornade',
    'value': {
      'type': 'observation',
      'path': 'properties.tornado',
      'unit': 'boolean'
    }
  }*/],
  'HEAVY_RAIN': [{
    'label': 'Cumul de précipitations sur 24 heures : données stations + radars + modèle',
    // 'labelParameters': ['observations.properties.closestStation.station.name', {path: 'observations.properties.closestStation.station.calculated_distance', transform: metersToKilometers}],
    'pdfLabel': "Total des précipitations sur 24 heures",
    'value': {
      'type': 'observation',
      'path': 'properties.closestStation.values.precipitation',
      'unit': 'mm'
    },
    'altValue': {
      'type': 'alert',
      'path': 'rain',
      'coefficient': 10,
    }
  }/*, {
    'label': 'Accumulation de précipitations sur la commune',
    'value': {
      'type': 'alert',
      'path': 'rain',
      'unit': 'mm'
    }
  }*/],
  'ICE': [{
    'label': 'Temperature minimale à la station météo la plus proche : station de %, située à % kms',
    'labelParameters': ['observations.properties.closestStation.station.name', {path: 'observations.properties.closestStation.station.calculated_distance', transform: metersToKilometers}],
    'value': {
      'type': 'observation',
      'path': 'properties.closestStation.values.min_temperature',
      'unit': 'degree'
    }
  }, {
    'label': 'Temperature du point de rosée à la station météo la plus proche : station de %, située à % kms',
    'labelParameters': ['observations.properties.closestStation.station.name', {path: 'observations.properties.closestStation.station.calculated_distance', transform: metersToKilometers}],
    'value': {
      'type': 'observation',
      'path': 'properties.closestStation.values.dew_point',
      'unit': 'degree'
    }
  }, {
    'label': 'Temperature minimale des stations de référence dans un rayon de % kms',
    'labelParameters': [{value: 30000, transform: metersToKilometers}],
    'value': {
      'type': 'observation',
      'path': 'properties.min_temperature',
      'unit': 'degree'
    }
  }, {
    'label': 'Temperature moyenne du point de rosée des stations de référence dans un rayon de % kms',
    'labelParameters': [{value: 30000, transform: metersToKilometers}],
    'value': {
      'type': 'observation',
      'path': 'properties.avg_dew_point',
      'unit': 'degree'
    }
  }, {
    'label': 'Temperature minimale du point de rosée des stations de référence dans un rayon de % kms',
    'labelParameters': [{value: 30000, transform: metersToKilometers}],
    'value': {
      'type': 'observation',
      'path': 'properties.min_dew_point',
      'unit': 'degree'
    }
  }, {
    'label': 'Temperature maximale du point de rosée des stations de référence dans un rayon de % kms',
    'labelParameters': [{value: 30000, transform: metersToKilometers}],
    'value': {
      'type': 'observation',
      'path': 'properties.max_dew_point',
      'unit': 'degree'
    }
  }],
  'TEMPERATURE': [{
    'label': 'Température à la station météo la plus proche : station de %, située à % kms',
    'labelParameters': ['observations.properties.closestStation.station.name', {path: 'observations.properties.closestStation.station.calculated_distance', transform: metersToKilometers}],
    'pdfLabel': "Température",
    'value': {
      'type': 'observation',
      'path': 'properties.closestStation.values.temperature',
      'unit': 'degree'
    }
  }, {
    'label': 'Température maximale à la station météo la plus proche : station de %, située à % kms',
    'labelParameters': ['observations.properties.closestStation.station.name', {path: 'observations.properties.closestStation.station.calculated_distance', transform: metersToKilometers}],
    'pdfLabel': "Température maximale",
    'value': {
      'type': 'observation',
      'path': 'properties.closestStation.values.max_temperature',
      'unit': 'degree'
    }
  }, {
    'label': 'Température minimale à la station météo la plus proche : station de %, située à % kms',
    'labelParameters': ['observations.properties.closestStation.station.name', {path: 'observations.properties.closestStation.station.calculated_distance', transform: metersToKilometers}],
    'pdfLabel': "Température minimale",
    'value': {
      'type': 'observation',
      'path': 'properties.closestStation.values.min_temperature',
      'unit': 'degree'
    }
  }],
  'SNOW': [{
    'label': 'Neige à la station météo la plus proche : station de %, située à % kms',
    'labelParameters': ['observations.properties.closestStation.station.name', {path: 'observations.properties.closestStation.station.calculated_distance', transform: metersToKilometers}],
    'value': {
      'type': 'observation',
      'path': 'properties.closestStation.values.snow',
      'unit': 'mm'
    }
  }],
  'THUNDER': [{
    'label': 'Présence de grêle',
    'value': {
      'type': 'alert',
      'path': 'hail',
      'unit': 'boolean'
    }
  }, {
    'label': 'Taille moyenne des grêlons',
    'value': {
      'type': 'alert',
      'path': 'hail_size_avg',
      'unit': 'cm'
    },
    'condition': {
      'type': 'alert',
      'path': 'hail',
    }
  }, {
    'label': 'Taille maximale des grêlons',
    'value': {
      'type': 'alert',
      'path': 'hail_size_max',
      'unit': 'cm'
    },
    'condition': {
      'type': 'alert',
      'path': 'hail',
    }
  }],
  'FLOOD': [{
    'label': 'Section de cours d\'eau',
    'value': {
      'type': 'alert',
      'path': 'section',
      'unit': 'text'
    }
  }],
  'POLLUTION': [{
    'label': 'Niveau 03',
    'value': {
      'type': 'alert',
      'path': 'polluants[0].level',
      'unit': 'text'
    }
  }, {
    'label': 'Niveau NO2',
    'value': {
      'type': 'alert',
      'path': 'polluants[1].level',
      'unit': 'text'
    }
  }, {
    'label': 'Niveau PM10',
    'value': {
      'type': 'alert',
      'path': 'polluants[2].level',
      'unit': 'text'
    }
  }, {
    'label': 'Niveau PM25',
    'value': {
      'type': 'alert',
      'path': 'polluants[3].level',
      'unit': 'text'
    }
  }],
  'SUBMERSION': [{
    'label': 'Hauteur des vagues',
    'value': {
      'type': 'alert',
      'path': 'wave_height',
      'unit': 'm'
    }
  }, {
    'label': 'Hauteur de houle',
    'value': {
      'type': 'alert',
      'path': 'swell_height',
      'unit': 'm'
    }
  }, {
    'label': 'Hauteur Total',
    'value': {
      'type': 'alert',
      'path': 'total_height',
      'unit': 'm'
    }
  }]
}

// TODO: filter out snow and rain values = 0
// TODO: test if we can limit ice to when it's cold and may be temperature close/below dew point
